import { useEffect } from 'react';

import useFluxibleAction from 'js/lib/fluxibleHooks/useFluxibleAction';
import useFluxibleStore from 'js/lib/fluxibleHooks/useFluxibleStore';

import { loadMembership } from 'bundles/in-course-stores/actions/CourseMembershipActions';
import CourseMembershipStore from 'bundles/in-course-stores/stores/CourseMembershipStore';
import CourseStore from 'bundles/in-course-stores/stores/CourseStore';

export const useLoadCourseMembership = () => {
  const { courseId } = useFluxibleStore(CourseStore, (store) => ({ courseId: store.getCourseId() }));

  const { loading, isEnrolled } = useFluxibleStore(CourseMembershipStore, (store) => ({
    loading: !store.hasLoaded(),
    isEnrolled: store.isEnrolled(),
  }));

  const executeAction = useFluxibleAction();

  useEffect(() => {
    if (courseId) {
      executeAction(loadMembership, courseId);
    }
  }, [courseId, executeAction]);

  return { loading, isEnrolled };
};
